<template>
  <div v-if="content" class="people-accordion">
    <div v-if="title" class="title">
      {{ title }}
    </div>
    <Accordion v-for="(list, index) in content" ref="accordion"
               :key="index"
               :anchor="category && category[index] && category[index][locale] ? category[index][locale].name : ''" :active="true"
    >
      <template v-if="(list && list.length) || category" slot="header">
        <div v-if="(type === 'movement')" class="header has-player">
          <a :class="{'disabled': pgnnpAudioMode}" href="#" class="btn-player" @click.prevent.stop="!pgnnpAudioMode ? setPlaylistToQueue(list) : null">
            <PlayerStaticPlayBtn width="32" height="32" :disabled="pgnnpAudioMode" />
            <!-- <svg width="32" height="32" class="static player-btn" viewBox="0 0 80 80">
              <circle class="circle-base" cx="40" cy="40" r="38" />
              <path class="play-btn" d="M31.93 52.033V27.967a3.059 3.059 0 0 1 4.844-2.482l16.723 12.032a3.059 3.059 0 0 1 0 4.966L36.774 54.515a3.059 3.059 0 0 1-4.845-2.482z" />
            </svg> -->
          </a>
          <RouterLink v-for="(person, pIndex) in list[0].performers.slice(0, 10)" :key="pIndex"
                      :to="{ name: 'performerById', params: { locale: $i18n.localePath(), id: person.people_id }}"
                      href="#" class="people-name"
          >
            {{ displayPerformerName(person.people) }}
          </RouterLink>
        </div>
        <div v-else-if="(type === 'track')" class="header has-player">
          <a :class="{'disabled': pgnnpAudioMode}" href="#" class="btn-player" @click.prevent.stop="!pgnnpAudioMode ? setPlaylistToQueue(list) : null">
            <PlayerStaticPlayBtn width="32" height="32" :disabled="pgnnpAudioMode" />
            <!-- <svg width="32" height="32" class="static player-btn" viewBox="0 0 80 80">
              <circle class="circle-base" cx="40" cy="40" r="38" />
              <path class="play-btn" d="M31.93 52.033V27.967a3.059 3.059 0 0 1 4.844-2.482l16.723 12.032a3.059 3.059 0 0 1 0 4.966L36.774 54.515a3.059 3.059 0 0 1-4.845-2.482z" />
            </svg> -->
          </a>
          <RouterLink v-for="(person, pIndex) in list[0].performers.slice(0, 10)" :key="pIndex"
                      :to="{ name: 'performerById', params: { locale: $i18n.localePath(), id: person.people_id }}"
                      href="#" class="people-name"
          >
            {{ displayPerformerName(person.people) }}
          </RouterLink>
        </div>
        <div v-else class="header">
          <h2>{{ category[index] && category[index][locale] ? category[index][locale].name : '' }}</h2>
        </div>
      </template>
      <template slot="content">
        <ul v-if="type === 'movement'" class="list-work">
          <li v-for="track in list" :key="track.id">
            <RouterLink :to="{ name: 'trackById', params: { locale: $i18n.localePath(), id: track.id }}">
              {{ displayMovementName(track) }}
            </RouterLink>
          </li>
        </ul>
        <ul v-else-if="(type === 'track') && list.length" class="list-work">
          <li v-for="track in list" :key="track.id">
            <RouterLink :to="{ name: 'trackById', params: { locale: $i18n.localePath(), id: track.id }}">
              {{ displayMovementName(track.movement) }}
            </RouterLink>
          </li>
        </ul>
        <ul v-else class="list-work">
          <li v-for="(work, wIndex) in list" :key="wIndex">
            <RouterLink :to="{ name: 'workById', params: { locale: $i18n.localePath(), workId: wIndex }}">
              {{ displayWorkName(work) }}
            </RouterLink>
          </li>
        </ul>
      </template>
    </Accordion>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Accordion from '@/components/common/Accordion'
import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'
import { displayTrackName, displayPerformerName, displayComposerName } from '@/assets/helpers/TrackHelper'
import { displayMovementName } from '@/assets/helpers/MovementHelper'
import { displayWorkName } from '@/assets/helpers/WorkHelper'
import { getCookie } from '@/assets/helpers/UtilHelper'

export default {
  components: {
    Accordion,
    PlayerStaticPlayBtn
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    category: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      pgnnpAudioMode: state => state.player.pgnnpAudioMode,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio,
      currentTime: state => state.player.currentTime,
      paused: state => state.player.paused
    }),
    locale() {
      return this.$i18n.locale.toLowerCase()
    }
  },
  created() {},
  methods: {
    displayTrackName,
    displayPerformerName,
    displayComposerName,
    displayMovementName,
    displayWorkName,
    getCookie,
    setPlaylistToQueue(playlist) {
      const isFirstPlay = this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else if (!this.paused || this.currentTime > 0) {
        this.$store.dispatch('INCREASE_PLAYING_COUNT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
      }
      this.$emit('play-track-list', playlist)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.people-accordion{
  margin-bottom: 36px;
  .title{
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey-50;
    margin-bottom: 16px;
  }
  .header{
    .people-name{
      display: inline-block;
      text-decoration: none;
      font-size: 16px;
      line-height: 1.6;
      font-weight: bold;
      color: $grey-9b;
      &:after{
        content: "/";
        display: inline-block;
        margin-right: 4px;
      }
      &:last-child:after{
        display: none;
      }
    }
    &.has-player{
      position: relative;
      padding-left: 38px;
      .btn-player{
        position: absolute;
        left: 0;
        top: -4px;
        &.disabled{
          user-select: none;
          cursor: not-allowed;
        }
      }
    }
  }
  .accordion-content{
    padding: 0;
    .list-work{
      list-style: none;
      margin: 0;
      padding: 0;
      li{
        display: block;
        width: 100%;
        border-bottom: 1px solid $grey-ec;
        a{
          display: block;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.6;
          color: $grey-7d;
          text-decoration: none;
          padding: 0 60px;
          transition: padding .3s ease-in-out;
        }
        &:last-child{
          border: 0;
        }
      }
    }
  }
  .accordion{
    &.active{
      .accordion-content{
        .list-work li a{
          padding: 10px 60px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1439.98px) {
  .people-accordion{
    .accordion-content{
      .list-work{
        li{
          a{
            padding: 0 40px;
          }
        }
      }
    }
    .accordion{
      &.active{
        .accordion-content{
          .list-work li a{
            padding: 10px 40px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1023.98px) {
  .people-accordion{
    .accordion-content{
      .list-work{
        li{
          a{
            padding: 0 30px;
          }
        }
      }
    }
    .accordion{
      &.active{
        .accordion-content{
          .list-work li a{
            padding: 10px 30px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .people-accordion{
    .accordion-content{
      .list-work{
        li{
          a{
            padding: 0 8px;
          }
        }
      }
    }
    .accordion{
      &.active{
        .accordion-content{
          .list-work li a{
            padding: 8px;
          }
        }
      }
    }
  }
}

</style>
